module.exports = __webpack_public_path__ + "static/img/bg-fr.c7340f73.png";